export enum AccountCategory {
  ACCOUNT_CATEGORY_PRE_409A = "Pre 409A",
  ACCOUNT_CATEGORY_409A = "409A",
}
